export default __webpack_public_path__ + "static/insta-hotels-8-34d1a15c27cc637b2c10464f25e91885.jpg";